export default {
  INSTALACAO: 1,
};
